import { Component, ElementRef, OnInit } from '@angular/core';
import {LocalStorageSettingsService} from '../../shared/services/local-storage-settings.service';
import {ErrorMessages} from '../../shared/common/errormessages';
import {validationmethod} from '../../shared/common/validationmethod';
import {ReportingServiceService} from '../../shared/services/reporting-service.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {FormBuilder} from '@angular/forms';
import {AssignUserRolePopupComponent} from '../assign-user-role/assign-user-role-popup/assign-user-role-popup.component';
import {ReportTemplatePopupComponent} from '../report-template-popup/report-template-popup.component';
import {TemplateReportPopupComponent} from './report-template-popup/template-report-popup.component';
import {TemplateReportService} from '../../shared/services/template-report.service';
import {Actionbutton} from '../../shared/common/Actionbutton';
import {constants} from '../../shared/common/contants';
import {CommonService} from '../../shared/services/common.service';
import { Reportdownload } from '../../shared/common/reportdownload';
import { configFileDownload } from 'src/app/shared/common/configFileDownload';
import {TemplateReportButtons} from '../../shared/common/template-report-buttons';
import { AdhocReportPopupComponent } from './adhoc-report-popup/adhoc-report-popup.component';
import { SelectFiltersPopUpComponent } from '../report-configuration/select-filters-pop-up/select-filters-pop-up.component';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { RoleAccessPermissionComponent } from './role-access-permission/role-access-permission.component';
import { RetrieveScreenAccess } from 'src/app/shared/models/userrole';
import {UserRoutingModule} from 'src/app/user/user-routing/user-routing.module';


@Component({
    selector: 'app-report-template',
    templateUrl: './report-template.component.html',
    styleUrls: ['./report-template.component.scss'],
    standalone: false
})
export class ReportTemplateComponent implements OnInit {
  rowbindingdata;

  //selectedTable;
  responserequest;

  paginationPageSize;

  paginationNumberFormatter;

  rowClassRules;

  lastpage;

  currentpage;

  nextpage;

  nextpageplusone;

  totalpages;

  pagesize;

  gridApi;

  gridColumnApi

  columnDefs

  defaultColDef

  components

  options: any;

  buttonColor

  value

  backgroundColorScreen
  private currentscreenId: any = 1075;

  gridOptions = {
    animateRows: true,
    enableSorting: true,
    enableCellChangeFlash: true,
    onGridReady: params => {
      params.api.expandAll();
    }
  };




  constructor(private userRoutingModule:UserRoutingModule,private retrieveScreenAccess:RetrieveScreenAccess,private msg: ErrorMessages,private constants:constants, private validation: validationmethod, private service: TemplateReportService,private commoService: CommonService, private spinner: NgxUiLoaderService, private snackbar: MatSnackBar, private dialog: MatDialog, private fb: FormBuilder,private localStorage: LocalStorageSettingsService,private reportLinkService:ReportlinksserviceService,private reportingService: ReportingServiceService,private selectedElement: ElementRef,) {
    this.components = {
      buttonRenderer: TemplateReportButtons,
      downloadReport:Reportdownload,
      downloadConfig: configFileDownload
    };
  }

  ngOnInit(): void {
    
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorage.getSettings('UserId')).subscribe(res => {
      console.log(res);
      const buttonIdList: any[] = [];
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       buttonIdList.push('screen');
       console.log('Button ID List:', buttonIdList);
      /**
       * @Modified by: Rahul Kulkarni
       * @Date: 2024-06-12
       * @Description:  Below Selection of buttons From DOM : code modified 
       *                instead of selecting all buttons from the Entire DOM 
       *                Select only the DOM of the CURRENT component, using ElementRef(selectedElement);
       *                 
       */
       const buttons = this.selectedElement.nativeElement.querySelectorAll('button'); 
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });

    
     

     
    this.backgroundColorScreen = this.localStorage.getSettings("ColorD");

    this.buttonColor = this.localStorage.getSettings("ColorA");

    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },

      sortable: true,

      resizable: true,

      filter: true

    };

    this.columnDefs=[
      {
        headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
        pinned:'left',
        lockPinned:true,
        cellRendererParams: {
          edit: this.editIcon.bind(this),
          delete: this.deleteIcon.bind(this),
          access_permission :this.access_permission.bind(this),
          schedule: this.scheduleIcon.bind(this),
          runAdhoc : this.runIcon.bind(this)
        }, width: 260

      },
     
      {
        headerName: 'Report Template Name',
        headerTooltip: 'Report Template Name',
        tooltipValueGetter: (params) =>
          'Report Template Name : ' + params.value,
        field: 'reportTemplateName',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Report Template Description',
        headerTooltip: 'Report Template Description',
        tooltipValueGetter: (params) =>
          'Report Template Description : ' + params.value,
        field: 'reportTemplateDescription',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Report Type',
        headerTooltip: 'Report Type',
        tooltipValueGetter: (params) =>
          'Report Type : ' + params.value,
        field: 'reportTypeName',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Template Type',
        headerTooltip: 'Template Type',
        tooltipValueGetter: (params) =>
          'Template Type : ' + params.value,
        field: 'templateTypeName',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Parent Template',
        headerTooltip: 'Parent Template',
        tooltipValueGetter: (params) =>
          'Parent Template : ' + params.value,
        field: 'parentTemplateName',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      {
        headerName: 'Download Report Template',
        headerTooltip: 'Download Report Template',
        tooltipValueGetter: (params) => 'Download Report Template',
        cellRenderer: 'downloadReport',
        cellRendererParams: {
          reportdownload: this.downloadReport.bind(this)
        },
        width: 200
      },
      {
        headerName: 'Download Configuration File',
        headerTooltip: 'Download Configuration File',
        tooltipValueGetter: (params) => 'Download Configuration File',
        cellRenderer: 'downloadConfig',
        cellRendererParams: {
          configFileDownload: this.downloadConfig.bind(this)
        },
        width: 200
      },
      {
        headerName: 'Binder Type',
        headerTooltip: 'Binder Type',
        tooltipValueGetter: (params) =>
          'Binder Type : ' + params.value,
        field: 'binderType',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Vault Binder Template',
        headerTooltip: 'Vault Binder Template',
        tooltipValueGetter: (params) =>
          'Vault Binder Template : ' + params.value,
        field: 'vaultBinderTemplate',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Binder Section',
        headerTooltip: 'Binder Section',
        tooltipValueGetter: (params) =>
          'Binder Section : ' + params.value,
        field: 'binderSectionName',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Merge Sub reports',
        headerTooltip: 'Merge Sub reports',
        tooltipValueGetter: (params) =>
          'Merge Sub reports : ' + params.value,
        field: 'mergeReports',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Document Type',
        headerTooltip: 'Document Type',
        tooltipValueGetter: (params) =>
          'Doc Type : ' + params.value,
        field: 'documentDocTypeLabel',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Document Lifecycle',
        headerTooltip: 'Document Lifecycle',
        tooltipValueGetter: (params) =>
          'Doc Type : ' + params.value,
        field: 'docLifecycle',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Document Sub Type',
        headerTooltip: 'Document Sub Type',
        tooltipValueGetter: (params) =>
          'Doc Sub Type : ' + params.value,
        field: 'documentDocSubTypeLabel',

        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Document Classification',
        headerTooltip: 'Document Classification',
        tooltipValueGetter: (params) =>
          'Doc Classification : ' + params.value,
        field: 'documentDocClassificationLabel',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Binder  Type',
        headerTooltip: 'Doc Type',
        tooltipValueGetter: (params) =>
          'Doc Type : ' + params.value,
        field: 'binderDocTypeLabel',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Binder Sub Type',
        headerTooltip: 'Doc Sub Type',
        tooltipValueGetter: (params) =>
          'Doc Sub Type : ' + params.value,
        field: 'binderDocSubTypeLabel',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Binder Document Classification',
        headerTooltip: 'Document Classification',
        tooltipValueGetter: (params) =>
          'Doc Classification : ' + params.value,
        field: 'binderDocClassificationLabel',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Dataset Name',
        headerTooltip: 'Dataset Name',
        tooltipValueGetter: (params) =>
          'Dataset Name : ' + params.value,
        field: 'dataSetName',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      // {
      //   headerName: 'Schedule For',
      //   headerTooltip: 'Schedule For',
      //   tooltipValueGetter: (params) =>
      //     'Schedule For : ' + params.value,
      //   field: 'scheduleFor',
      //   filter: 'agTextColumnFilter',
      //   width: 180,
      // },
      {
        headerName: 'Quick Sight Reference',
        headerTooltip: 'Quick Sight Reference',
        tooltipValueGetter: (params) =>
          'Quick Sight Reference : ' + params.value,
        field: 'quickSightReference',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Created By',
        headerTooltip: 'Created By',
        tooltipValueGetter: (params) =>
          'Created By : ' + params.value,
        field: 'createdBy',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Created Date',
        headerTooltip: 'Created Date',
        tooltipValueGetter: (params) =>
          'Created Date : ' + params.value,
        field: 'createdDate',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      
      {
        headerName: 'Last Modified By',
        headerTooltip: 'Last Modified By',
        tooltipValueGetter: (params) =>
          'Last Modified By : ' + params.value,
        field: 'lastModifiedBy',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Last Modified Date',
        headerTooltip: 'Last Modified Date',
        tooltipValueGetter: (params) =>
          'Last Modified Date: ' + params.value,
        field: 'lastModifiedDate',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      {
        headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) => 'Status : ' + params.value,
        field: 'status',
        filter: 'agTextColumnFilter',
        width: 150,
        cellStyle: function (params) {
          if (params.value == 'Yes') {
            return { color: 'green' };
          } else {
            return { color: 'red' };
          }
        }
      },
       {
        headerName: 'Report Template Id',
        headerTooltip: 'Report Template Id',
        tooltipValueGetter: (params) =>
          'Report Template Id : ' + params.value,
        field: 'reportTemplateId',
        filter: 'agTextColumnFilter',
        width: 100,
      },
      

    ]
    this.paginationPageSize = 10;

    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };

    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };




    this.spinner.start();
    this.reportLinkService.fetchUserRole(this.localStorage.getSettings("dnsName"),this.localStorage.getSettings("AuthUsername")).subscribe(res => {
      console.log(res);
      this.responserequest = res;

      if (res.error == true) {

        this.spinner.stop();

        this.snackbar.open(res.statusMessage, 'OK', {duration: 5000});
        return

      }
      
    });

  }

  //excel export function
  onBtExport() {
    this.rowbindingdata.api.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridApi) {
      this.lastpage = this.gridApi.paginationIsLastPageFound();
      this.currentpage = this.gridApi.paginationGetCurrentPage() + 1
      this.nextpage = this.gridApi.paginationGetCurrentPage() + 1 + 1
      this.nextpageplusone = this.gridApi.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalpages = this.gridApi.paginationGetTotalPages()
    }
  }
  //this function is for going to the given page number
  onSearchChange(searchValue: number) {

    this.rowbindingdata.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {
    var value = this.pagesize
    this.rowbindingdata.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.rowbindingdata.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.rowbindingdata.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first")
    this.rowbindingdata.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last")
    this.rowbindingdata.api.paginationGoToLastPage();
  }
  //pagination code ends

  onGridReady(params){
    this.rowbindingdata = params;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.spinner.start()
    this.service.retrieveReportTemplatesByDnsId().subscribe(response=>{
     
      console.log(response);
      

      if (response.error == true) {

        this.spinner.stop();

        this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});


      } else {

        this.spinner.stop();
        this.gridApi.setGridOption('rowData', response);


      }
    })


  }
  /* @Added BY Ravi G
    @Date 20/02/2023
    @Desc template Report Popup Download for insert and update and data for report template
  */
  openSaveForm(){

    let dialogRef = this.dialog.open(TemplateReportPopupComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: '55%',
      maxWidth: '100vw',
      height: "95%",
      autoFocus: false,
      data: { edata:undefined},
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result=>{
      this.onGridReady(this.rowbindingdata)
    })

  }



  access_permission(e){
    
    console.log(e.rowData)
    console.log(e.rowData.report_ownerRoleid)
    if(e.rowData.status != 'Yes') {
      this.snackbar.open(this.constants.deleterowMsg, 'OK', {duration: 5000});
    }


    
     console.log(e)
    
     console.log(this.responserequest)
    if (this.responserequest.roleName !== e.rowData.report_ownerRoleid){
      this.snackbar.open(this.constants.Access_report_Denied, "OK", { duration: 5000 });
      return;
    }
    else{

      console.log(e.rowData)
      let dialogRef = this.dialog.open(RoleAccessPermissionComponent, {
        panelClass: 'custom-dialog-container-materialFulfilment',
        width: '55%',
        autoFocus: false,
        data: { edata: e.rowData },
        disableClose: true,
      });
  
      dialogRef.afterClosed().subscribe(result=>{
        this.onGridReady(this.rowbindingdata)
      })
    }
  
  } 

    
  


  
  editIcon(e){

    if(e.rowData.status != 'Yes') {
      this.snackbar.open(this.constants.deleterowMsg, 'OK', {duration: 5000});
      return;
    }

    

     console.log(e)
    
     console.log(this.responserequest)
    if (this.responserequest.roleName !== e.rowData.report_ownerRoleid){
      this.snackbar.open(this.constants.Access_report_Denied, "OK", { duration: 5000 });
      return;
    }
    else{
    console.log(e.rowData)
    let dialogRef = this.dialog.open(TemplateReportPopupComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: '55%',
      maxWidth: '100vw',
      height: "95%",
      autoFocus: false,
      data: { edata: e.rowData},
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result=>{
      this.onGridReady(this.rowbindingdata)
    })
  }
  
  }

  rowClicked(e){
    if(e.data.status == 'Yes') {
      let dialogRef = this.dialog.open(TemplateReportPopupComponent, {
        panelClass: 'custom-dialog-container-materialFulfilment',
        width: '55%',
        maxWidth: '100vw',
        height: "95%",
        autoFocus: false,
        data: {edata: e.data},
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe(result => {
        this.onGridReady(this.rowbindingdata)
      })
    }else{
      this.snackbar.open(this.constants.deleterowMsg, 'OK', {duration: 5000});

    }
  }


  deleteIcon(e){

    if(e.rowData.status != 'Yes') {
      this.snackbar.open(this.constants.deleterowMsg, 'OK', {duration: 5000});
      return;
    }

    


     console.log(e)
    
     console.log(this.responserequest)
    if (this.responserequest.roleName !== e.rowData.report_ownerRoleid){
      this.snackbar.open(this.constants.Access_report_Denied, "OK", { duration: 5000 });
      return;
    }
    else{

      if (confirm(this.constants.confirmDeletion)) {
        this.spinner.start()
        this.service.deleteReportTemplateById(e.rowData.reportTemplateId).subscribe(response => {

          if (response.error == true) {

            this.spinner.stop();

            this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});

          } else {

            this.spinner.stop();
            this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});
            this.onGridReady(this.rowbindingdata)

          }

        })
      }
    }
  

  }
  s3FilePath
  downloadReport(e) {
   

    if(e.rowData.status == 'Yes') {
      this.s3FilePath = e.rowData.templateFilePath

      if (this.s3FilePath === undefined || this.s3FilePath === "" || this.s3FilePath === null) {

        this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

      } else {
        let fileName = e.rowData.templateFileName
        let data = {
          s3Path: this.s3FilePath,
        };
        this.spinner.start();
        this.commoService.downloadFileFromS3(data).subscribe(x => {
          this.spinner.stop()
          // It is necessary to create a new blob object with mime-type explicitly set
          // otherwise only Chrome works like it should

          console.log(x)
          const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
          const responseData = isJsonBlob(x)
          if (responseData) {
            this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

          } else {
            console.log(x)
            var newBlob = new Blob([x]);
            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            //   window.navigator.msSaveOrOpenBlob(newBlob);
            //   return;
            // }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            console.log(data)

            var link = document.createElement('a');
            link.href = data;
            link.download = fileName;
            // this is necessary as link.click() does not work on the latest firefox
            link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));
            setTimeout(function() {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(data);
              link.remove();
            }, 100);

          }

        })

        this.spinner.stop();
      }
    }else{

      this.snackbar.open(this.constants.deleterowMsg, 'OK', {duration: 5000});

    }
  }

  downloadConfig(e, type) {
    console.log(e, type);

    if (e.rowData.status == 'Yes') {
      this.s3FilePath = e.rowData.configfilepath

      if (this.s3FilePath === undefined || this.s3FilePath === "" || this.s3FilePath === null) {

        this.snackbar.open(this.constants.fileNotFound, "OK", { duration: 5000 });

      } else {
        let fileName = e.rowData.configFileName
        let data = {
          s3Path: this.s3FilePath,
        };
        this.spinner.start();
        this.commoService.downloadFileFromS3(data).subscribe(x => {
          this.spinner.stop()
          // It is necessary to create a new blob object with mime-type explicitly set
          // otherwise only Chrome works like it should

          console.log(x)
          const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
          const responseData = isJsonBlob(x)
          if (responseData) {
            this.snackbar.open(this.constants.fileNotFound, "OK", { duration: 5000 });

          } else {
            console.log(x)
            var newBlob = new Blob([x]);
            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            //   window.navigator.msSaveOrOpenBlob(newBlob);
            //   return;
            // }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            console.log(data)

            var link = document.createElement('a');
            link.href = data;
            link.download = fileName;
            // this is necessary as link.click() does not work on the latest firefox
            link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
            setTimeout(function () {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(data);
              link.remove();
            }, 100);

          }

        })

        this.spinner.stop();
      }
    } else {

      this.snackbar.open(this.constants.deleterowMsg, 'OK', { duration: 5000 });

    }
  }


  scheduleIcon(e) {

    console.log(e);

    console.log(e.rowData.reportTemplateId);
    let manageFilters;
    if(e.rowData.manageFiltersIds.trim().length > 0){
      manageFilters = e.rowData.manageFiltersIds.split(',').map(Number);
    }else{
      manageFilters = []
    }
    let dialogRef = this.dialog.open(ReportTemplatePopupComponent, {
      maxWidth: '100vw',
      height: "95%",
      width: "80%",
      data: { "reportName": e.rowData.reportTemplateName,"reportTemplateId":e.rowData.reportTemplateId ,"screenName":'Report Template',"datasetid":e.rowData.datasetId,"selectedFiltersArray":manageFilters}
    });


  }

  // added by Nitin Kumar
  // Desc:- where Report Type is Report Binder set diff row color
  getRowStyle = (params) => {
    if (params.data.reportTypeName === 'Report Binder') {
      return { background: '#f2f2f2' }; // Change the background color to yellow for rows with report type 'Report Binder'
    }
    return null;
  };
/**
 * @author Abhishek Tomar
 * @date 2024-08-29
 * @description This function formats we are using for retriving the dataset for accociated with the reports
 */
  async getDatasetDetails(datasetId,templateid,rowData) {
    let  objectgroupid=0;
    let datasetDetails: any
     try {
       this.spinner.start()
       const response = await this.reportingService.retrieveDatasetDetails(datasetId).toPromise();
       console.log(response);
       datasetDetails = response;
       console.log(datasetDetails);
        objectgroupid=datasetDetails.objectGroup
        this.selectFilterPopup(datasetId,objectgroupid,templateid,datasetDetails,rowData);
       // Additional logic that depends on the datasetDetails can go here
     } catch (error) {
       console.error('Error retrieving dataset details:', error);
     }
   }

 runIcon(e){
  console.log("inside run")
  console.log(e.rowData);
  let filterArray:any[]=[];
  this.getDatasetDetails(e.rowData.datasetId,e.rowData.reportTemplateId,e.rowData)
 }
    /**
 * @author Abhishek Tomar
 * @date 2024-08-29
 * @description function to open the filter pop-up and updating the value of filter which user selecting
 * and making the filters compatible with the EMR and passing the filterid for report creation
 */
  formatForInString(input): string {
    // Split the input string by commas
    console.log(input);
    console.log(typeof input)
  
    // Trim whitespace and enclose each item in single quotes
    const formattedItems = input.map(item => `'${item.trim()}'`);
  
    // Join the formatted items with commas
    return formattedItems.join(', ');
  }
  selectFilterPopup(datasetid,objectgroup,templateid,datasetDetails,rowData){
    console.log(datasetDetails);
    let manageFilters;
    if(rowData.manageFiltersIds.trim().length > 0){
      manageFilters = rowData.manageFiltersIds.split(',').map(Number);
    }else{
      manageFilters = []
    }
  let dialogRef = this.dialog.open(SelectFiltersPopUpComponent, {
    width: "70%",
    autoFocus: false,
    maxWidth: '100vw',
    height: "90%",
    disableClose: true,
     data: { dataSetId: datasetid, objectGroup : objectgroup,columnsData:datasetDetails.columns,datasetData:datasetDetails,selectedFiltersArray:manageFilters,hideReportName:true}
  });
  let where=[]
  const distinctFilterManageIds = new Set<number>();
  const selectedFilterArray=[]
   dialogRef.afterClosed().subscribe(result => {
          console.log(result);
    
    if(result.selectedFiltersListString){
          let getdata= JSON.parse(result.selectedFiltersListString)
          
          let filterMap = new Map<number, any[]>();
          
         

          // Group filters by filtermanageId
          getdata.forEach((filter: any) => {
            filter.filterType = "reportFilter"
            let filtermanageId = filter.manageFilterId;
            distinctFilterManageIds.add(filtermanageId);
            delete filter.manageFilterId
            if (!filterMap.has(filtermanageId)) {
              filterMap.set(filtermanageId, []);
            }

            switch (filter.whereConditionValue) {
              case "Ends with":
                filter.whereCondition="LIKE";
                filter.whereValue = `%${filter.whereValue}`;
                break;
                
              case "Starts with":
                filter.whereCondition="LIKE";
                filter.whereValue = `${filter.whereValue}%`;
                break;
              case "contains":
                filter.whereValue = `%${filter.whereValue}%`;
                break;
                 case "Contains (Exclude)":
                filter.whereValue = `%${filter.whereValue}%`;
                break;
                case "BETWEEN":
                  filter.whereValue1 = `'${filter.whereValue1}'`.replace(/\//g, "-");
                  
                  filter.whereValue = `${filter.whereValue}`.replace(/\//g, "-")
               
                  break;

                case "IN":
                  filter.whereValue = `(${this.formatForInString(filter.whereValue)})`;
                  break;
                   case "NOT IN":
                  filter.whereValue = `(${this.formatForInString(filter.whereValue)})`;
                  break;
              default:
                break;
            }
            
            if(filter.type=="DateTime"&&filter.whereValue=="Invalid date"){
              // console.log(filter.whereValue=="'Invalid date'")
              filter.whereValue=''
            }
            if (filter.whereConditionValue!="IN" && filter.whereConditionValue!="NOT IN" ){
            filter.whereValue = `'${filter.whereValue}'`;
            }
            //Ignoring the calculatedfield
            if (filter.whereConditionValue.toLowerCase() !== "calculatedfield".toLowerCase() && filter.whereConditionValue.toLowerCase() !== "CalculatedFieldWithFilter".toLowerCase()){
            filterMap.get(filtermanageId)?.push(filter);
            selectedFilterArray.push(filter);
            }
          });

          if(Array.from(distinctFilterManageIds).length>0){
            let obj={
              filtermanageids:Array.from(distinctFilterManageIds).join(','),
              selectedFilter:JSON.stringify(selectedFilterArray)
            }
            where.push(obj)
           }
         
                  
                   this.reportLinkService.adhocReport(templateid, 0,where,result.reportName).subscribe(); 
                   this.snackbar.open("Report Initiated", "OK", {
                    duration: 5000,
                  });
                }

  } );


}

}
 
